/**
 * Client-side Dil Utility Fonksiyonları
 * 
 * Bu dosya, client-side component'lerde kullanılan dil yönetimi için
 * ortak utility fonksiyonları içerir.
 */

export interface LanguageAttributes {
    code: string;
    name: string;
    is_default: boolean;
    direction: string;
    svg_code?: string;
    native_name: string;
    region: string;
}

export interface Language {
    id: number;
    attributes: LanguageAttributes;
}

/**
 * Cookie'de saklanan dil anahtarları
 */
export const LANG_COOKIE_KEYS = ["language", "userLang"] as const;

/**
 * Client-side: Cookie'ye dil kodunu set et
 */
export function setLanguageCookies(code: string): void {
    const cookieValue = `; path=/; max-age=${365 * 24 * 60 * 60}; SameSite=Lax`;
    LANG_COOKIE_KEYS.forEach((key) => {
        document.cookie = `${key}=${code}${cookieValue}`;
    });
}

/**
 * Client-side: Pathname'den dil kodunu çıkarır
 * 
 * @param pathname - Mevcut pathname
 * @param languages - Mevcut diller listesi
 * @returns Dil kodu veya undefined
 */
export function resolveLanguageFromPath(
    pathname: string | null | undefined,
    languages: Language[]
): string | undefined {
    if (!pathname) return undefined;

    const pathSegments = pathname.split('/').filter(Boolean);
    const firstSegment = pathSegments[0];

    if (firstSegment && /^[a-z]{2}$/.test(firstSegment)) {
        const match = languages.find(lang => lang.attributes.code === firstSegment);
        return match?.attributes.code;
    }

    return undefined;
}

